import { BaseService } from "./BaseService";

export class SystemLogsService extends BaseService {
  constructor() {
    super("/admin/system-logs");
  }

  async listLogs() {
    try {
      const response = await this.getClient().get("/admin/system-logs");
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async downloadLog(filename) {
    try {
      const response = await this.getClient().get(
        `/admin/system-logs/download/${filename}`,
        {
          responseType: "blob",
        }
      );

      // Create a blob from the response data
      const blob = new Blob([response.data], { type: "text/plain" });
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger download
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return { success: true };
    } catch (error) {
      this.handleError(error);
      return { success: false, error: error.message };
    }
  }
}